/* Catalunya -> comarca -> municipality. Geometry loads once, on first drill-down. */
(function () {
  'use strict';
  var NS = 'http://www.w3.org/2000/svg';
  var selector = '[data-municipality-explorer]';
  var translations = {
    ca: {
      initial: 'Per quina comarca comencem?', regionHint: 'Tria una comarca per veure\'n els municipis.',
      regionMouse: 'Fes clic en una comarca per explorar-ne els municipis.', regionTouch: 'Toca una comarca per seleccionar-la. Torna-la a tocar o prem «Veure municipis» per entrar-hi.',
      municipalityHint: 'Tria un municipi per descobrir-ne el mapa de 15 km.',
      municipalityMouse: 'Passa el cursor per veure el nom. Fes clic per obrir el mapa.',
      municipalityTouch: 'Toca un municipi i després prem «Veure municipi».',
      chooseMunicipality: 'Tria un municipi', municipalities: 'municipis', available: 'Descobreix el mapa del municipi i el seu entorn.',
      unavailable: 'Mapa encara no disponible.', view: 'Veure municipi', viewRegion: 'Veure municipis',
      mapLabel: 'Mapa interactiu de les comarques de Catalunya', municipalityMap: 'Municipis de ',
      loading: 'Carregant els municipis…', error: 'No s\'ha pogut carregar el mapa. Trobaràs els mapes disponibles a la col·lecció, tot seguit.',
      regionError: 'No s\'han pogut carregar els municipis. Torna a triar la comarca per provar-ho de nou.'
    },
    es: {
      initial: '¿Por qué comarca empezamos?', regionHint: 'Elige una comarca para ver sus municipios.',
      regionMouse: 'Haz clic en una comarca para explorar sus municipios.', regionTouch: 'Toca una comarca para seleccionarla. Tócala de nuevo o pulsa «Ver municipios» para entrar.',
      municipalityHint: 'Elige un municipio para descubrir su mapa de 15 km.',
      municipalityMouse: 'Pasa el cursor para ver el nombre. Haz clic para abrir el mapa.',
      municipalityTouch: 'Toca un municipio y después pulsa «Ver municipio».',
      chooseMunicipality: 'Elige un municipio', municipalities: 'municipios', available: 'Descubre el mapa del municipio y su entorno.',
      unavailable: 'Mapa todavía no disponible.', view: 'Ver municipio', viewRegion: 'Ver municipios',
      mapLabel: 'Mapa interactivo de las comarcas de Catalunya', municipalityMap: 'Municipios de ',
      loading: 'Cargando los municipios…', error: 'No se ha podido cargar el mapa. Encontrarás los mapas disponibles en la colección, a continuación.',
      regionError: 'No se han podido cargar los municipios. Vuelve a elegir la comarca para intentarlo de nuevo.'
    }
  };

  function productUrl(entry, config) {
    if (!entry || entry.published !== true || entry.available !== true) return null;
    var ca = config.locale === 'ca';
    var source = ca ? (entry.urlCa || entry.url_ca) : (entry.urlEs || entry.url_es);
    if (!source && entry.handle) source = '/products/' + encodeURIComponent(entry.handle);
    if (!source) return null;
    try {
      var url = new URL(source, window.location.origin);
      var storeOrigin = new URL(config.storeOrigin || 'https://trobart.cat').origin;
      if ((url.origin !== window.location.origin && url.origin !== storeOrigin) || !/\/products\/[^/]+\/?$/.test(url.pathname)) return null;
      var localeRoot = (config.rootUrl || '/').replace(/\/$/, '');
      if (localeRoot && url.pathname.indexOf('/products/') === 0) url.pathname = localeRoot + url.pathname;
      var preview = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
      return url.pathname + url.search + url.hash;
    } catch (_) { return null; }
  }

  function requestJSON(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('asset unavailable');
      return response.json();
    });
  }

  async function mount(root) {
    if (root.dataset.municipalityMounted) return;
    root.dataset.municipalityMounted = 'true';
    var config;
    try { config = JSON.parse(root.querySelector('[data-municipality-config]').textContent); }
    catch (_) { return; }
    var copy = translations[config.locale === 'ca' ? 'ca' : 'es'];
    var canvas = root.querySelector('[data-municipality-canvas]');
    var loading = root.querySelector('[data-municipality-loading]');
    var regionSelect = root.querySelector('[data-region-select]');
    var municipalitySelect = root.querySelector('[data-municipality-select]');
    var municipalityControl = root.querySelector('[data-municipality-control]');
    var back = root.querySelector('[data-municipality-back]');
    var level = root.querySelector('[data-map-level]');
    var name = root.querySelector('[data-selection-name]');
    var status = root.querySelector('[data-selection-status]');
    var link = root.querySelector('[data-municipality-link]');
    var regionAction = root.querySelector('[data-region-action]');
    var legend = root.querySelector('[data-municipality-legend]');
    var mouseInstruction = root.querySelector('[data-instruction-mouse]');
    var touchInstruction = root.querySelector('[data-instruction-touch]');
    var geometry, catalogue;
    var regions = new Map(), entries = new Map(), municipalities = new Map(), areas = new Map();
    var currentRegion = null, selected = null, previewRegion = null;
    // Only an explicit touch/pen click confirms a comarca; hover and focus cannot.
    var tappedRegion = null;
    var bundlePromise = null, requestToken = 0;
    var lastPointer = { type: '', at: 0 };

    function isTouchClick(event) {
      if (event.pointerType === 'touch' || event.pointerType === 'pen') return true;
      if (event.pointerType === 'mouse' || event.detail === 0) return false;
      if ((lastPointer.type === 'touch' || lastPointer.type === 'pen') && Date.now() - lastPointer.at < 1500) return true;
      return !!(window.matchMedia && window.matchMedia('(hover: none)').matches);
    }

    function busy(value) {
      canvas.setAttribute('aria-busy', String(value));
      canvas.classList.toggle('is-loading', value && !!canvas.querySelector('svg'));
      loading.hidden = !value;
      if (value) loading.textContent = copy.loading;
      regionAction.disabled = value;
    }

    function hideActions() {
      regionAction.hidden = true;
      link.hidden = true;
      link.removeAttribute('href');
      link.removeAttribute('aria-label');
    }

    function highlight(id) {
      if (selected && areas.has(selected)) areas.get(selected).classList.remove('is-selected');
      selected = id;
      if (id && areas.has(id)) areas.get(id).classList.add('is-selected');
    }

    function preview(region) {
      if (currentRegion) return;
      highlight(region.id);
      previewRegion = region.id;
      name.textContent = region.name;
      var count = region.municipalityCount || (region.municipalityIds || []).length;
      status.textContent = count ? count + ' ' + copy.municipalities : copy.regionHint;
      regionAction.hidden = false;
      regionAction.setAttribute('aria-label', copy.viewRegion + ' · ' + region.name);
      link.hidden = true;
    }

    function chooseMunicipality(place) {
      if (!place || !currentRegion) return;
      highlight(place.id);
      municipalitySelect.value = place.id;
      name.textContent = place.name;
      status.textContent = place.url ? copy.available : copy.unavailable;
      regionAction.hidden = true;
      link.hidden = !place.url;
      if (place.url) {
        link.href = place.url;
        link.setAttribute('aria-label', copy.view + ' · ' + place.name);
      } else { link.removeAttribute('href'); link.removeAttribute('aria-label'); }
    }

    function clearMunicipality() {
      highlight(null);
      municipalitySelect.value = '';
      hideActions();
      name.textContent = currentRegion ? currentRegion.name : copy.initial;
      status.textContent = currentRegion ? copy.municipalityHint : copy.regionHint;
    }

    function svgElement(viewBox, label) {
      var svg = document.createElementNS(NS, 'svg');
      svg.setAttribute('class', 'tbme__map');
      svg.setAttribute('viewBox', viewBox.join(' '));
      svg.setAttribute('role', 'group');
      svg.setAttribute('aria-label', label);
      return svg;
    }

    function areaElement(place, isRegion) {
      var area = document.createElementNS(NS, !isRegion && place.url ? 'a' : 'g');
      area.setAttribute('class', 'tbme__area' + (!isRegion && !place.url ? ' tbme__area--unavailable' : ''));
      area.setAttribute(isRegion ? 'data-region-id' : 'data-municipality-id', place.id);
      area.setAttribute('tabindex', '0');
      area.setAttribute('aria-label', place.name + (!isRegion && !place.url ? ' · ' + copy.unavailable : ''));
      if (!isRegion && place.url) area.setAttribute('href', place.url);
      else {
        area.setAttribute('role', 'button');
      }
      var title = document.createElementNS(NS, 'title');
      title.textContent = place.name;
      var path = document.createElementNS(NS, 'path');
      path.setAttribute('class', 'tbme__shape');
      path.setAttribute('d', place.path);
      path.setAttribute('fill-rule', 'evenodd');
      area.appendChild(title);
      area.appendChild(path);
      function choose() { if (isRegion) preview(place); else chooseMunicipality(place); }
      area.addEventListener('pointerenter', function (event) { if (event.pointerType !== 'touch') choose(); });
      area.addEventListener('focus', choose);
      area.addEventListener('pointerdown', function (event) { lastPointer = { type: event.pointerType, at: Date.now() }; });
      area.addEventListener('keydown', function (event) {
        if (isRegion && (event.key === 'Enter' || event.key === ' ')) {
          event.preventDefault();
          showRegion(place.id, true);
        } else if (!isRegion && !place.url && (event.key === 'Enter' || event.key === ' ')) {
          event.preventDefault();
          chooseMunicipality(place);
        }
      });
      area.addEventListener('click', function (event) {
        var touch = isTouchClick(event);
        if (isRegion) {
          event.preventDefault();
          if (touch && tappedRegion !== place.id) {
            tappedRegion = place.id;
            preview(place);
          } else showRegion(place.id, !touch && event.detail === 0);
          return;
        }
        choose();
        if (touch || !place.url) event.preventDefault();
      });
      areas.set(place.id, area);
      return area;
    }

    function replaceMap(svg) {
      var previous = canvas.querySelector('svg');
      if (previous) previous.remove();
      canvas.appendChild(svg);
      busy(false);
    }

    function sorted(array) {
      return array.slice().sort(function (a, b) { return a.name.localeCompare(b.name, config.locale || 'ca'); });
    }

    function showCatalunya(focusRegionId) {
      requestToken++;
      currentRegion = null;
      previewRegion = null;
      tappedRegion = null;
      selected = null;
      areas.clear();
      municipalities.clear();
      root.dataset.level = 'regions';
      regionSelect.value = '';
      municipalityControl.hidden = true;
      municipalitySelect.disabled = true;
      back.hidden = true;
      legend.hidden = true;
      level.textContent = 'Catalunya';
      mouseInstruction.textContent = copy.regionMouse;
      touchInstruction.textContent = copy.regionTouch;
      hideActions();
      name.textContent = copy.initial;
      status.textContent = copy.regionHint;
      var svg = svgElement(geometry.viewBox, copy.mapLabel);
      sorted(geometry.regions).forEach(function (region) { svg.appendChild(areaElement(region, true)); });
      replaceMap(svg);
      if (focusRegionId && areas.has(focusRegionId)) areas.get(focusRegionId).focus({ preventScroll: true });
    }

    function municipalityGeometry(region) {
      if (Array.isArray(geometry.municipalities) && geometry.municipalities.some(function (place) { return place.path; })) {
        return Promise.resolve({ viewBox: region.viewBox, municipalities: geometry.municipalities.filter(function (place) { return place.regionId === region.id; }) });
      }
      if (!bundlePromise) {
        var assetName = root.dataset.municipalitiesUrl || geometry.municipalityAssetName || region.assetName;
        if (!assetName) return Promise.reject(new Error('missing municipality asset'));
        var assetUrl = new URL(assetName, new URL(root.dataset.geometryUrl, window.location.href));
        bundlePromise = requestJSON(assetUrl.href).catch(function (error) { bundlePromise = null; throw error; });
      }
      return bundlePromise.then(function (bundle) {
        var detail = Array.isArray(bundle.regions) && bundle.regions.find(function (item) { return item.id === region.id; });
        if (detail && Array.isArray(detail.municipalities)) return detail;
        if (Array.isArray(bundle.municipalities)) return { viewBox: region.viewBox, municipalities: bundle.municipalities.filter(function (place) { return place.regionId === region.id; }) };
        throw new Error('missing region geometry');
      });
    }

    function detailViewBox(region, detail) {
      if (Array.isArray(detail.viewBox) && detail.viewBox.length === 4) return detail.viewBox;
      if (Array.isArray(region.viewBox) && region.viewBox.length === 4) return region.viewBox;
      var bounds = region.bounds;
      if (!Array.isArray(bounds) || bounds.length !== 4) return geometry.viewBox;
      var padding = Math.max(bounds[2], bounds[3]) * .045;
      return [bounds[0] - padding, bounds[1] - padding, bounds[2] + padding * 2, bounds[3] + padding * 2];
    }

    async function showRegion(id, moveFocus) {
      var region = regions.get(id);
      if (!region) return;
      tappedRegion = null;
      var token = ++requestToken;
      hideActions();
      back.hidden = false;
      municipalitySelect.disabled = true;
      busy(true);
      try {
        var detail = await municipalityGeometry(region);
        if (token !== requestToken || !root.isConnected) return;
        if (!Array.isArray(detail.municipalities) || !detail.municipalities.length) throw new Error('empty municipality geometry');
        currentRegion = region;
        previewRegion = null;
        selected = null;
        areas.clear();
        municipalities.clear();
        root.dataset.level = 'municipalities';
        regionSelect.value = region.id;
        municipalitySelect.replaceChildren();
        var placeholder = document.createElement('option');
        placeholder.value = ''; placeholder.textContent = copy.chooseMunicipality;
        municipalitySelect.appendChild(placeholder);
        var svg = svgElement(detailViewBox(region, detail), copy.municipalityMap + region.name);
        sorted(detail.municipalities).forEach(function (source) {
          if (source.regionId && source.regionId !== region.id) return;
          var entry = entries.get(source.id) || entries.get('ES:' + source.code);
          if (entry && entry.regionId && entry.regionId !== region.id) entry = null;
          var place = Object.assign({}, source, { url: productUrl(entry, config) });
          municipalities.set(place.id, place);
          var option = document.createElement('option');
          option.value = place.id;
          option.textContent = place.name + (place.url ? '' : ' · ' + copy.unavailable);
          municipalitySelect.appendChild(option);
          svg.appendChild(areaElement(place, false));
        });
        municipalityControl.hidden = false;
        municipalitySelect.disabled = false;
        back.hidden = false;
        legend.hidden = false;
        level.textContent = region.name;
        mouseInstruction.textContent = copy.municipalityMouse;
        touchInstruction.textContent = copy.municipalityTouch;
        clearMunicipality();
        replaceMap(svg);
        if (moveFocus) level.focus({ preventScroll: true });
      } catch (_) {
        if (token !== requestToken || !root.isConnected) return;
        busy(false);
        regionSelect.value = currentRegion ? currentRegion.id : '';
        back.hidden = !currentRegion;
        municipalitySelect.disabled = !currentRegion;
        name.textContent = region.name;
        status.textContent = copy.regionError;
        hideActions();
      }
    }

    regionSelect.addEventListener('change', function () {
      tappedRegion = null;
      if (regionSelect.value) showRegion(regionSelect.value, false);
      else showCatalunya();
    });
    municipalitySelect.addEventListener('change', function () {
      tappedRegion = null;
      if (municipalitySelect.value) chooseMunicipality(municipalities.get(municipalitySelect.value));
      else clearMunicipality();
    });
    back.addEventListener('click', function () { var previous = currentRegion && currentRegion.id; showCatalunya(previous); });
    regionAction.addEventListener('click', function () { if (previewRegion) showRegion(previewRegion, true); });

    try {
      var results = await Promise.allSettled([requestJSON(root.dataset.geometryUrl), requestJSON(root.dataset.productsUrl)]);
      if (results.some(function (result) { return result.status !== 'fulfilled'; })) throw new Error('initial asset unavailable');
      geometry = results[0].value; catalogue = results[1].value;
      if (!root.isConnected) return;
      if (!Array.isArray(geometry.regions) || !Array.isArray(geometry.viewBox) || !Array.isArray(catalogue.municipalities)) throw new Error('invalid explorer data');
      catalogue.municipalities.forEach(function (entry) {
        if (entry.id) entries.set(entry.id, entry);
        if (entry.code && (!entry.id || entry.id === 'ES:' + entry.code)) entries.set('ES:' + entry.code, entry);
      });
      sorted(geometry.regions).forEach(function (region) {
        regions.set(region.id, region);
        var option = document.createElement('option');
        option.value = region.id; option.textContent = region.name;
        regionSelect.appendChild(option);
      });
      regionSelect.disabled = false;
      showCatalunya();
    } catch (_) {
      if (!root.isConnected) return;
      busy(false);
      loading.hidden = false;
      loading.textContent = copy.error;
      hideActions();
      regionSelect.disabled = true;
      municipalitySelect.disabled = true;
    }
  }

  function init(scope) {
    if (scope.matches && scope.matches(selector)) mount(scope);
    scope.querySelectorAll(selector).forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  if (!window.trobartMunicipalityExplorerBound) {
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
    window.trobartMunicipalityExplorerBound = true;
  }
})();
